import { Route } from "react-router-dom";
import { lazyWithRetry as lazy } from "@/lib/lazyWithRetry";
import ProtectedRoute from "@/components/ProtectedRoute";
import FeatureRoute from "@/components/FeatureRoute";

const RegieLayout = lazy(() => import("@/pages/regie/RegieLayout"));
const RegieDashboardPage = lazy(() => import("@/pages/regie/RegieDashboardPage"));
const RegieScreensPage = lazy(() => import("@/pages/regie/ScreensPage"));
const RegiePackagesPage = lazy(() => import("@/pages/regie/PackagesPage"));
const RegieContractsListPage = lazy(() => import("@/pages/regie/ContractsListPage"));
const RegieContractFormPage = lazy(() => import("@/pages/regie/ContractFormPage"));
const RegieContractDetailPage = lazy(() => import("@/pages/regie/ContractDetailPage"));
const RegieCalendarPage = lazy(() => import("@/pages/regie/CalendarPage"));
const RegieRapportPage = lazy(() => import("@/pages/regie/RapportRegiePage"));
const EventsLayout = lazy(() => import("@/pages/evenements/EventsLayout"));
const EventsCalendarPage = lazy(() => import("@/pages/evenements/EventsCalendarPage"));
const EventFormPage = lazy(() => import("@/pages/evenements/EventFormPage"));
const EventDetailPage = lazy(() => import("@/pages/evenements/EventDetailPage"));
const EventTypesConfigPage = lazy(() => import("@/pages/evenements/EventTypesConfigPage"));
const EventsRapportPage = lazy(() => import("@/pages/evenements/EventsRapportPage"));

export function regieEvenementsRoutes() {
  return (
    <>
      {/* Régie publicitaire */}
      <Route
        element={
          <ProtectedRoute allowedRoles={["gerante", "admin", "pdg", "controleur"]}>
            <FeatureRoute flag="pos.regie"><RegieLayout /></FeatureRoute>
          </ProtectedRoute>
        }
      >
        <Route path="/regie" element={<RegieDashboardPage />} />
        <Route path="/regie/ecrans" element={<RegieScreensPage />} />
        <Route path="/regie/forfaits" element={<RegiePackagesPage />} />
        <Route path="/regie/contrats" element={<RegieContractsListPage />} />
        <Route path="/regie/contrats/nouveau" element={<RegieContractFormPage />} />
        <Route path="/regie/contrats/:id" element={<RegieContractDetailPage />} />
        <Route path="/regie/calendrier" element={<RegieCalendarPage />} />
        <Route path="/regie/rapport" element={<RegieRapportPage />} />
      </Route>

      {/* Événements internes (layout avec sous-routes) */}
      <Route
        element={
          <ProtectedRoute allowedRoles={["gerante", "admin", "pdg", "controleur", "chef_salle", "caissiere"]}>
            <FeatureRoute flag="pos.evenements"><EventsLayout /></FeatureRoute>
          </ProtectedRoute>
        }
      >
        <Route path="/evenements" element={<EventsCalendarPage />} />
        <Route path="/evenements/rapport" element={<EventsRapportPage />} />
        <Route path="/evenements/types" element={<EventTypesConfigPage />} />
      </Route>

      {/* Événements sans layout wrapper */}
      <Route
        path="/evenements/nouveau"
        element={
          <ProtectedRoute allowedRoles={["gerante", "admin", "chef_salle"]}>
            <FeatureRoute flag="pos.evenements"><EventFormPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/evenements/:id"
        element={
          <ProtectedRoute allowedRoles={["gerante", "admin", "pdg", "controleur", "chef_salle", "caissiere"]}>
            <FeatureRoute flag="pos.evenements"><EventDetailPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/evenements/:id/edit"
        element={
          <ProtectedRoute allowedRoles={["gerante", "admin", "chef_salle"]}>
            <FeatureRoute flag="pos.evenements"><EventFormPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
    </>
  );
}
